import { render, staticRenderFns } from "./DropdownGroupsContent.vue?vue&type=template&id=b2c46d56&scoped=true"
import script from "./DropdownGroupsContent.vue?vue&type=script&lang=js"
export * from "./DropdownGroupsContent.vue?vue&type=script&lang=js"
import style0 from "./DropdownGroupsContent.vue?vue&type=style&index=0&id=b2c46d56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2c46d56",
  null
  
)

export default component.exports